import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'custom-field',
  templateUrl: './custom-field.component.html',
  styleUrls: ['./custom-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldComponent extends FieldType<FieldTypeConfig> {}
